import { FC } from 'react';

import { BaseModal } from 'wbs-components-lib';

import { Box } from '@mui/material';

import { TelegramChatSettings } from '../TelegramChatSettings';

import { TelegramChatSettingsChatModalProps } from './types';

import styles from './TelegramChatSettingsModal.module.css';

const { telegramChatModalContent, telegramChatModalContainer } = styles;

export const TelegramChatSettingsModal: FC<TelegramChatSettingsChatModalProps> = ({
  isOpened,
  handleClose,
  telegramChat,
}) => (
  <BaseModal
    headerTitle="Chat"
    isOpened={isOpened}
    handleClose={handleClose}
    isFooterNeeded={false}
    extraContainerClass={telegramChatModalContainer}
  >
    <Box className={telegramChatModalContent}>
      <TelegramChatSettings telegramChat={telegramChat} />
    </Box>
  </BaseModal>
);
